import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { DateString, NonNegativeMonetaryValue } from '../fields';

const baseShape = {
  loanId: LosId,
  disbursementType: z.enum(['escrow']),
  disbursementDate: DateString,
  disbursementTotal: NonNegativeMonetaryValue,
  payeeId: z.string().optional(),
  disbursementRecipient: z.string().optional(),
  policyNumber: z.string().optional(),
  updateNextPaymentAmount: z.boolean().optional(),
  note: z.string().optional(),
};

const baseObject = z.object(baseShape);

export const RecordEscrowDisbursementRow = baseObject.superRefine((row, ctx) => {
  if (!row.payeeId && !row.disbursementRecipient) {
    ctx.addIssue({
      code: 'custom',
      path: ['disbursementRecipient'],
      message: 'Either payeeId or disbursementRecipient is required.',
    });
  }
});
export type RecordEscrowDisbursementRow = z.infer<typeof RecordEscrowDisbursementRow>;

export const RECORD_ESCROW_DISBURSEMENT_ROW_REQUIRED_FIELDS = Object.keys(baseShape).filter(
  (key) => !baseShape[key as keyof typeof baseShape].isOptional(),
);
